import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header from "../SharedSection/Header/Header";

const Blogs = () => {
    return (
        <div style={{ paddingBottom: "700px", paddingTop: "100px" }}>
            <Header />
            <div className="container">
                <img
                    className="img-fluid"
                    src="https://i.ibb.co/Yf8y8BG/Coming-soon-neon-banner-vector-template-Glowing-night-bright-lettering-sign-for-advertisement.jpg"
                    alt="Page-not-found"
                />
                <br />
                <br />
                <p className="text-primary">Please Wait.........</p>
                <br />
                <Link to="/">
                <Button className="fs-4 text-warning" variant="">
                    Go To Home
                </Button>
            </Link>
            </div>
        </div>
    );
};

export default Blogs;
